import React from 'react'
import styled from 'styled-components';







export default function StepsIndicator({
  currentSlide,
  setCarouselCurrentSlide
}) {

  const items = [2, 3];

  return (
    <StepsIndicatorWrapper>
      {items.map((item) => {
        return (
          <Indicator
            key={item}
            onClick={() => {
              setCarouselCurrentSlide(item)
            }}
            style={{
              flexGrow: currentSlide === item && "1",
              width: currentSlide === item && "44px",
              backgroundColor: currentSlide === item && "#ed7100"
            }}
          />
        )
      })}
    </StepsIndicatorWrapper>
  )
}



const StepsIndicatorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: start;
  justify-content: center;
  margin-top: 3rem;
  align-content: center;
  position: relative;
  bottom: 0;
`;

const Indicator = styled.div`
  background-color: #FEE6D0;
  border-radius: 88px;
  height: 6px;
  cursor: pointer;
  width: 20px;
`;